import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, ArrowRight } from "lucide-react";
import { useFinance } from "@/context/FinanceContext";
import { logReminder } from "@/lib/insights";

// Gentle, non-nagging in-app reminder. Client-side only.
export function LogReminderBanner({ className = "" }) {
  const navigate = useNavigate();
  const { finance, acknowledgeReminder } = useFinance();
  const r = useMemo(() => logReminder(finance), [finance]);

  if (!r.show) return null;

  return (
    <div
      className={`flex items-start gap-3 rounded-3xl border border-zinc-200 bg-white p-4 shield-shadow ${className}`}
      data-testid="log-reminder-banner"
    >
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-2xl bg-emerald-50 text-emerald-600">
        <Bell className="h-4.5 w-4.5" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-sm leading-relaxed text-zinc-700">
          Sudah {r.daysSince} hari belum ada catatan. Ada pemasukan atau pengeluaran yang terlewat?
        </p>
        <div className="mt-3 flex flex-wrap gap-2">
          <button
            data-testid="log-reminder-cta-catat"
            onClick={() => navigate("/app/catat")}
            className="inline-flex h-9 items-center gap-1.5 rounded-full bg-zinc-900 px-4 text-xs font-semibold text-white"
          >
            Catat sekarang <ArrowRight className="h-3.5 w-3.5" />
          </button>
          <button
            data-testid="log-reminder-cta-none"
            onClick={() => acknowledgeReminder(r.todayISO)}
            className="inline-flex h-9 items-center rounded-full border border-zinc-200 px-4 text-xs font-semibold text-zinc-500"
          >
            Tidak ada transaksi
          </button>
        </div>
      </div>
    </div>
  );
}
